export const trackGoal = (goalName) => {
  if (typeof window.ym === 'function') {
    window.ym(97097353, 'reachGoal', goalName);
  }
};
